import React, { Component } from 'react';
import { Table, Spin, Select } from 'antd';
import TableText from "../../TableText";
const { Option } = Select;
const totalIndexFooter = [0, 24, 26, 32, 44, 50, 54, 59];
class index extends Component {
    onChange = (name, value, i) => {
        // 简单粗暴的深拷贝
        let data = JSON.parse(JSON.stringify(this.props.data));
        data[i][name] = value;
        this.props.onChange('name', data);
    }
    render() {
        const data = this.props.data;
        const columns = [{
            title: '-',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return <div
                    className={`table-padding ${totalIndexFooter.includes(index) ? 'table-color-footer' : ''}`}
                    style={{ textAlign: "left" }}
                >
                    {!totalIndexFooter.includes(index) ? <Select
                        style={{ width: "100%", textAlign: "right" }}
                        defaultValue={text}
                        onChange={v => this.onChange('name', v, index)}

                    >
                        <Option value={0}>0</Option>
                        <Option value={1}>1</Option>
                    </Select> : text}
                </div>
            }
        }, {
            title: 'RISKS / CONTROLS',
            dataIndex: 'risks',
            key: 'risks',
            align: "center",
            width: 650,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'text', name: "risks", onChange: this.onChange, totalIndex: totalIndexFooter,
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'File Reference',
            dataIndex: 'file',
            key: 'file',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'text', name: "file", onChange: this.onChange, totalIndex: totalIndexFooter,
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Comments',
            dataIndex: 'control',
            key: 'control',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: totalIndexFooter.includes(index) ? 'text' : "textArea", name: "control", onChange: this.onChange, totalIndex: totalIndexFooter,
                };
                return (
                    <TableText data={props} />
                )
            }
        }];
        return (
            <Table
                columns={columns}
                dataSource={data}
                size="middle"
                bordered
                pagination={false}
                loading={this.props.loading}
                className="content"
                scroll={this.props.print ? {} : { y: 500 }}
                rowKey={(record, index) => record.id || record.sort}
            />
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-10/2-1.js